var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"mb-4 justify-center"},[_vm._v(" "+_vm._s(_vm.$t('insertTheCodeDialogueFrame.code-for-insert'))+" ")]),_c('p',{on:{"click":function($event){_vm.$emit('copy-code', _vm.getText())}}},[_vm._v(" "+_vm._s(_vm.getText())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }